// src/icons/presetWrapper.js
export const withDefaultSize = (wrappedFn, width, height) => {
  return (props) => wrappedFn({ width, height, ...props });
};
